import { call, put, takeEvery } from "redux-saga/effects";
import { giangVienBanApi } from "../../../api/category/giangVienBanApi";
import { IGiangVienBan } from "../../../model/respone/category/IGiangVienBan";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eGiangVienBanActionIds,
  IGiangVienBanActionTypes,
} from "../../action-types/category/IGiangVienBanActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.giangVienBan;

export function* giangVienBanSaga(): any {
  yield takeEvery(eGiangVienBanActionIds.LOAD_START, loadWorker);
  yield takeEvery(eGiangVienBanActionIds.SAVE_START, saveWorker);
  yield takeEvery(eGiangVienBanActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(giangVienBanApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}
function* saveWorker(action: IGiangVienBanActionTypes): any {
  const payload = action.payload as IGiangVienBan;
  const res: IBaseRespone = payload.id > 0
    ? yield call(giangVienBanApi.Update, payload)
    : yield call(giangVienBanApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_SUCCESS(res.data));
  else yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
}
function* deleteWorker(action: IGiangVienBanActionTypes): any {
  const res: IBaseRespone = yield call(giangVienBanApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_SUCCESS(res.data));
  else yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
}
